import { constants } from "ethers";

export const NUMBER_INPUT_REGEX = (decimals: number) =>
  new RegExp(`^\\d*[.,]?\\d{0,${decimals}}$`);
export const TRANSFER_FEE_IN_CASH = "950000";
export const CASH_TOKEN_ADDRESS_BY_CHAIN = {
  "11155111": "0x1c7d4b196cb0c7b01d743fbc6116a902379c7238",
  "84532": "0x036cbd53842c5426634e7929541ec2318f3dcf7e",
  "1": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
  "8453": "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
  "43114": "0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e",
  "42161": "0xaf88d065e77c8cc2239327c5edb3a432268e5831",
  "10": "0x0b2c639c533813f4aa9d7837caf62653d097ff85",
  "137": "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359",
};

export const DEFAULT_CHAIN_ID =
  process.env.NODE_ENV === "development" ? "11155111" : "1";
export const DEFAULT_TOKEN_ADDR = constants.AddressZero;
export const DEFAULT_REQUEST_ABORT_MSG = "Request deprecated";
export const GAS_LIMIT_MULTIPLIER = 1.1;
export const IS_PRODUCTION_ENV = process.env.NODE_ENV !== "development";
export const PRIVY_APP_ID =
  process.env.NODE_ENV === "development"
    ? "cm8ismqiw003k8qo9b8y4o4sh" //"cm8ismqiw003k8qo9b8y4o4sh"
    : "cm9rb68l200m7jo0liu899rh9";
export const PRIVY_APP_ID_DEV = "cm8ismqiw003k8qo9b8y4o4sh";
export const GET_PIMLICO_URL = (chainId: string) =>
  `https://api.pimlico.io/v2/${chainId}/rpc?apikey=pim_H5UzibAGJcQ5rhKu3VFFsX`;
export const SWAPPER_FINANCE_URL = "https://swapper.finance";
export const FIVE_MINUTES = 5 * 60 * 1000;
export const AUTO_REFRESH_INTERVAL = 30000; // 30 seconds
export const FEES_WARNING_RATIO = 0.2;
export const FEES_ERROR_RATIO = 0.5;
export const IS_DEBUG_MODE = IS_PRODUCTION_ENV ? false : true;
